const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the  totals-chart directive to display the chart for Existing X v New X
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 * @argument {Resource} Overview the resource defined to get Overview queries
 * @argument {Resource} Analyze the resource defined to get Analyze data
 */
app.directive('totalsChart', [
  'Application',
  'Overview',
  'Analyze',
  '$translate',
  function (Application, Overview, Analyze, $translate) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        for: '@',
        headline: '@',
        action: '=?',
        of: '=?',
      },
      template: require('../../../templates/directives/overview/totals-chart.html'),
      controller: [
        '$scope',
        function ($scope) {
          var self = this;
          self.for = '';
          self.headline = 'Headline';
          self.labels = [];

          // chart config
          $translate(['modules.totalsChart.labelExisting', 'modules.totalsChart.labelNew']).then(function (
            translations
          ) {
            self.labels = [
              translations['modules.totalsChart.labelExisting'],
              translations['modules.totalsChart.labelNew'],
            ];
          });

          self.getColors = function () {
            return Application.chartColors;
          };
          self.colors = self.getColors();
          //need to set colors based on brand
          self.initialize = function () {
            if ($scope.for) {
              self.for = $scope.for;
              self.headline = $scope.headline;

              var subresource = { subresource: self.for.toLowerCase(), users: 'all' };

              if (subresource.subresource === 'learning tracks') {
                subresource.subresource = 'tracks';
              }
              if (subresource.subresource === 'sessions' || subresource.subresource === 'signins') {
                subresource.subresource = 'authtokens';
                if (!$scope.action) {
                  subresource.action = 'signin';
                }
              }
              switch (subresource.subresource) {
                case 'authtokens':
                case 'views':
                case 'likes':
                case 'signups':
                case 'waitlist':
                case 'shares':
                  if (subresource.subresource === 'signups') {
                    subresource.subresource = 'events';
                    subresource.action = 'signup';
                  }
                  if (subresource.subresource === 'waitlist') {
                    subresource.subresource = 'events';
                    subresource.action = 'waitlist';
                  }
                  if ($scope.action) {
                    subresource.action =
                      $scope.action.slice(0, -1) === 's'
                        ? $scope.action.toLowerCase().slice(0, -1)
                        : $scope.action.toLowerCase();
                  }
                  if ($scope.of) {
                    subresource.content_type =
                      $scope.of.slice(0, -1) === 's' ? $scope.of.toLowerCase().slice(0, -1) : $scope.of.toLowerCase();
                  }
                  Analyze.totals(
                    subresource,
                    function (data) {
                      // Get total total-up-to-last-month and total-up-to-the-month-before-last
                      self.total = data['total_' + subresource.subresource];
                      self.totalUpToLastMonth = data['total_' + subresource.subresource + '_up_to_last_month'];
                      self.data = [self.total, self.total - self.totalUpToLastMonth];
                      if (self.total === 0) {
                        self.data = [1, 0];
                      }
                    },
                    function (error) {
                      console.log('Error getting totals:', error, subresource);
                      self.data = [1, 0];
                    }
                  );
                  break;
                default:
                  Overview.totals(
                    subresource,
                    function (data) {
                      self.data = [data['total_' + subresource.subresource], data['new_' + subresource.subresource]];
                      if (data['total_' + subresource.subresource] === 0) {
                        self.data = [1, 0];
                      }
                    },
                    function (error) {
                      console.log('Error getting overview totals:', error, subresource);
                      self.data = [1, 0];
                    }
                  );
              }
            }
          };
          self.initialize();
        },
      ],
      controllerAs: 'totals',
    };
  },
]);
